import React, { useState } from 'react';
import axios from 'axios';
import ReactLoading from 'react-loading';
import Pagination from './Pagination';
import Card from './Card';

class News extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			isLoadedLibrary: false,
			isLoadedFilters: false,
			isLoadedContent: false,
			mainClass: 'hide',
			queryParams: {},
			filters: [],
			items: [],
			pagination: {},
			sticky: {},
		};

		this.handleSingleFilter = this.handleSingleFilter.bind(this);
		this.handleSearchFilter = this.handleSearchFilter.bind(this);
		this.handlePage = this.handlePage.bind(this);
	}

	componentDidMount() {
		// Prepopulate queryParams in this.state with URL query params.
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const urlParamsEntries = urlParams.entries();

		const defaultQueryParams = {};

		for (const item of urlParamsEntries) {
			if (item[1].length > 0) {
				if (item[1].includes(',')) {
					// Arrays need to be converted from "x,y" to [x,y].
					defaultQueryParams[item[0]] = item[1].split(',');
				} else {
					// String.
					defaultQueryParams[item[0]] = item[1];
				}
			}
		}

		// Set the default state and afterwards, fetch data
		this.setState(
			{
				queryParams: defaultQueryParams,
			},
			() => {
				this.fetchFilters();
				this.fetchData();
			}
		);
	}

	componentWillUnmount() {
		{
			/* eslint-disable no-useless-return */
		}
		this.setState = () => {
			return;
		};
	}

	fetchFilters() {
		// Get the taxonomy data for the dropdown and checkbox filters
		const fetchUrl = new URL(
			'/wp-json/northlandcollege/v1/news/filters',
			window.location.protocol + window.location.hostname
		);

		axios
			.get(fetchUrl)
			.then((response) => {
				this.setState({
					isLoadedFilters: true,
					filters: response.data,
				});
			})
			.catch((error) => {
				this.setState({
					isLoadedFilters: false,
					error,
				});
			});
	}

	fetchData() {
		const fetchUrl = new URL(
			'/wp-json/northlandcollege/v1/news',
			window.location.protocol + window.location.hostname
		);

		// Populate both the parameters for the REST request and for
		// updating the URL.
		const urlParams = [];

		if (this.state.queryParams !== {}) {
			Object.keys(this.state.queryParams).forEach((key) => {
				const value = this.state.queryParams[key];
				if (Array.isArray(value) && value.length > 0) {
					// Arrays need to be converted from [x,y] to "x,y".
					fetchUrl.searchParams.append(key, value.join(','));
					urlParams.push([key, value.join(',')].join('='));
				} else {
					fetchUrl.searchParams.append(key, value);
					const tmpValue = value + '';
					if (tmpValue.length > 0 && tmpValue !== '0') {
						urlParams.push([key, value].join('='));
					}
				}
			});
		}

		// Update the URL with GET parameters.
		if (urlParams.length > 0) {
			const urlUpdate = '?' + urlParams.join('&');
			history.pushState(this.state.queryParams, '', urlUpdate);
		} else {
			history.pushState(
				this.state.queryParams,
				'',
				window.location.pathname
			);
		}

		axios.get(fetchUrl).then(
			(response) => {
				// Successfully got results.
				this.setState({
					isLoadedLibrary: true,
					isLoadedContent: true,
					items: response.data.posts,
					sticky: response.data.sticky,
					pagination: response.data.pagination,
					mainClass: 'show',
				});
			},
			(error) => {
				// Error getting results.
				this.setState({
					isLoadedLibrary: false,
					isLoadedContent: false,
					error,
				});
			}
		);
	}

	// Process select and search filters.
	handleSearchFilter(event) {
		if ('Enter' === event.key || 'Return' === event.key) {
			this.setState(
				(state) => ({
					isLoadedContent: false,
					queryParams: {
						...state.queryParams,
						[event.target.id]: event.target.value,
					},
				}),
				this.fetchData
			);
		}
	}

	handleSingleFilter(event) {
		this.setState(
			(state) => ({
				isLoadedContent: false,
				queryParams: {
					...state.queryParams,
					[event.target.id]: event.target.value,
				},
			}),
			this.fetchData
		);
	}

	handlePage(event) {
		// Update the page and fetch new data for pagination
		event.preventDefault();

		const page = event.target.value > 1 ? event.target.value : 0;

		this.setState(
			(state) => ({
				isLoadedContent: false,
				queryParams: {
					...state.queryParams,
					pg: page,
				},
			}),
			this.fetchData
		);
	}

	render() {
		const {
			error,
			isLoadedFilters,
			isLoadedLibrary,
			isLoadedContent,
			items,
			filters,
			pagination,
			sticky,
		} = this.state;

		if (error) {
			return <div>Error: { error.message }</div>;
		}

		const defaultCategory = '';

		const hasResults = items.length > 0 ? true : false;

		const results = items.map((item) => (
			<Card post={ item } key={ item.ID } />
		));

		const noResults = <h2 className="no-results">No news items found for those filters</h2>;

		const defaultSearch = this.state.queryParams[ 'news-search' ] || '';

		let hasQueryParams = false;

		if (
			this.state.queryParams &&
			Object.keys(this.state.queryParams).length > 0
		) {
			for (const name in this.state.queryParams) {
				if (this.state.queryParams[name]) {
					hasQueryParams = true;
				}
			}
		}

		return (
			<>
				<section className="news-search-filter">
					<h2 className="visually-hidden">News search and filter</h2>
					<div className="search-filter-wrapper">
						<div className="search-wrapper">
							<label
								className="visually-hidden"
								htmlFor="news-search"
							>
								Search news
							</label>
							<input
								type="search"
								id="news-search"
								defaultValue={ defaultSearch }
								className="search form-control"
								placeholder="Search news"
								onKeyDown={ this.handleSearchFilter }
								autoComplete="off"
							/>
						</div>
						<div className="filter-wrapper">
							{isLoadedFilters ? (
								<select
									id="categories"
									className="category-dropdown form-select"
									onChange={ this.handleSingleFilter }
									defaultValue={ defaultCategory }
									aria-label="Filter by category"
								>
									<option value="" key="all">
										All Topics
									</option>
									{filters.categories.map((item) => (
										<option value={ item.key } key={ item.key }>
											{ item.value }
										</option>
									))}
								</select>
							) : null}
						</div>
					</div>
				</section>

				{isLoadedContent && this.state.sticky && ! hasQueryParams ? (
					<section className="news-media-text-block">
						<div className="news-row-wrapper">
							<div className="row news-row">
								<div className="column text-left">
									{sticky.post_title ? (
										<h2>{ sticky.post_title }</h2>
									) : (
										''
									)}

									{sticky.date_formatted ? (
										<p>{ sticky.date_formatted }</p>
									) : (
										''
									)}
									<ul className="sticky-list">
										<li>
											<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><title>View link</title><circle cx="25" cy="25" r="25" fill="#fff"/><rect x="23" y="28" width="12" height="2" transform="translate(-12.01 29) rotate(-45)" fill="#01172e"/><rect x="28" y="15" width="2" height="12" transform="translate(-6.36 26.66) rotate(-45)" fill="#01172e"/><rect x="16" y="24" width="16" height="2" fill="#01172e"/></svg>
										</li>
										<li className="read-more">
											<a href={ sticky.link }>Read more</a>
										</li>
									</ul>
								</div>
								<div className="column media-right">
									<img
										className="cover-image"
										src={ sticky.thumbnail }
										alt={ sticky.thumbnail_alt }
									/>
								</div>
							</div>
						</div>
					</section>
				) : (
					''
				)}
				{isLoadedContent ? (
					<section className="program-grid-wrapper">
						<div className="northland-card">
							<h2 className="visually-hidden">News list</h2>
							<div className="row" aria-live="polite">
								{ hasResults ? results : noResults }
							</div>
						</div>
					</section>
				) : (
					<div className="loading product-gallery-loading">
						<ReactLoading
							type="bars"
							color="#aaa"
							height="40px"
							width="40px"
						/>
					</div>
				)}

				<Pagination
					pagination={ pagination }
					handlePage={ this.handlePage }
					pg={ this.state.queryParams.pg }
					contentLoaded={ this.state.isLoadedContent }
				/>
			</>
		);
	}
}

export default News;
